import { Component, OnInit } from '@angular/core';
import { GlobalUtilsService } from '../../global-utils.service';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
})
export class LogoComponent implements OnInit {
  constructor(public globalUtilsService: GlobalUtilsService) {}

  ngOnInit() {}
}
